import ActionType from '../actions/ActionType'

export default (
  state = {
    loaded: false,
    error: false,
    preferences: {},
    settings: {},
  },
  action,
) => {
  switch (action.type) {
    case ActionType.AccountSettings.LIST_SUCCESS:
      return {
        ...state,
        loaded: true,
        settings: action.payload,
      }
    case ActionType.AccountSettings.LIST_FAILURE:
      return {
        ...state,
        error: action.payload,
      }
    case ActionType.AccountSettings.UPDATE_SUCCESS:
      return {
        ...state,
        loaded: true,
        settings: action.payload,
      }
    case ActionType.AccountSettings.UPDATE_FAILURE:
      return {
        ...state,
        error: action.payload,
      }
    case ActionType.AccountSettings.LIST_PREFERENCES_SUCCESS:
      return {
        ...state,
        loaded: true,
        preferences: action.payload,
      }
    case ActionType.AccountSettings.LIST_PREFERENCES_FAILURE:
      return {
        ...state,
        error: action.payload,
      }
    case ActionType.AccountSettings.UPDATE_PREFERENCES_SUCCESS:
      return {
        ...state,
        loaded: true,
        preferences: action.payload,
      }
    case ActionType.AccountSettings.UPDATE_PREFERENCES_FAILURE:
      return {
        ...state,
        error: action.payload,
      }
    case ActionType.Data.READ_SUCCESS:
      if (action.entityType === 'account/preference') {
        return {
          ...state,
          loaded: true,
          preferences: action.payload,
        }
      }

      if (action.entityType === 'account') {
        return {
          ...state,
          loaded: true,
          settings: action.payload,
        }
      }
      return state
    case ActionType.Data.UPDATE_SUCCESS:
      if (action.entityType === 'account/preference') {
        return {
          ...state,
          loaded: true,
          preferences: action.payload,
        }
      }

      if (action.entityType === 'account') {
        return {
          ...state,
          loaded: true,
          settings: action.payload,
        }
      }
      return state
    default:
      return state
  }
}
